import type { MnemonicsFullListQuery } from '@api/dto/gql-helpers.generated';
import { useMnemonicsFullListSuspenseQuery } from '@api/dto/gql-helpers.generated';
import type { ApolloQueryResult } from '@apollo/client';
import { useCallback } from 'react';

export type Mnemonic =
  MnemonicsFullListQuery['classifiers']['mnemonic']['list']['items'][number];

export interface UseMnemonicsResult {
  getList: (params?: { groupName: string }) => Mnemonic[];
  getDictionary: (params: { groupName: string }) => Record<string, Mnemonic>;
  refetch: () => Promise<ApolloQueryResult<MnemonicsFullListQuery>>;
}

export function useMnemonics(): UseMnemonicsResult {
  const { data, refetch } = useMnemonicsFullListSuspenseQuery({
    variables: {
      orderBy: [{ id: 'ASC' }],
    },
  });
  const getList = useCallback(
    (params?: { groupName: string }) => {
      const list = data.classifiers.mnemonic.list.items;

      if (!params) return list;
      return list.filter(i => i.group_name === params.groupName);
    },
    [data],
  );
  const getDictionary = useCallback(
    (params: { groupName: string }) => {
      const list = getList(params);
      return list.reduce<Record<string, Mnemonic>>((dictionary, item) => {
        dictionary[item.mnemonic] = item;
        return dictionary;
      }, {});
    },
    [getList],
  );

  return { getDictionary, getList, refetch };
}
